/** Payment status label used for display and translation keys. Values are lowercase. */
export enum PaymentStatusLabel {
  IncomingPayment = 'incoming_payment',
  Paid = 'paid',
  WrittenOff = 'written_off',
  Overdue = 'overdue',
  NotPaid = 'not_paid',
  PartlyPaid = 'partly_paid',
  Cancelled = 'cancelled',
  PartlyCredited = 'partly_credited',
  Credited = 'credited',
  CreditNote = 'credit_note',
  CardTransactionFailed = 'card_transaction_failed',
  OK = 'ok',
}
